export default {
  alerts: {
    title: "Email alerts",
    errorPrefix: "Error: ",
    alertCreated: "Alert created",
    loadError: "Could not load the information. Check your connection.",
    retry: "Retry",
    tabMyAlerts: "My alerts ({n})",
    tabHistory: "History ({n})",
    tabEmailPrefs: "Email preferences",
    newSubscription: "New alert subscription",
    changeType: "Change type",
    any: "Any",
    activeIngredient: "Active substance",
    activeIngredientPlaceholder: "e.g. Progesterone",
    minRelevance: "Min. relevance",
    create: "+ Create",
    thType: "Type",
    thActiveIngredient: "Ingredient",
    thMinRelevance: "Min. relevance",
    thCreated: "Created",
    thStatus: "Status",
    noSubs: "No alerts configured",
    active: "Active",
    paused: "Paused",
    delete: "Delete",
    logChangeId: "Event ID",
    logChannel: "Channel",
    logStatus: "Status",
    logSent: "Sent",
    logError: "Error",
    noLog: "No alert history",
    types: {
      new_entry: "New entry",
      price_change: "Price change",
      reimbursement_change: "Reimbursement",
      exclusion: "Exclusion",
      deduction: "Deduction",
      warning: "Notice",
      marketing_status: "Market status",
      eu_registration: "EU registration",
      regulation: "Regulation",
      exclusivity: "Exclusivity",
    },
    sevTitle: "Which alerts reach you by email",
    sevIntro: "Based on each milestone's level in your organisation's severity table, for your products and for your competitors. What arrives highlighted as “[CRITICAL]” is decided by each milestone's critical-alert mark (in Severity), not by the level.",
    sevLink: "See the severity table →",
    sevLevel: "Level",
    sevOwn: "Your portfolio",
    sevCompetitor: "Your competitors",
    sevNote: "What you leave unticked still appears in Events and in the Alerts inbox: it just stops arriving by email.",
    lvlA: "A · Deadline: action required",
    lvlD: "D · Assess whether it affects you",
    lvlI: "I · For your information",
    prefsIntro: "Choose which emails you receive at the address linked to your account.",
    prefsLoadError: "Could not load the preferences",
    prefsSaved: "Preferences saved",
    prefsSaveError: "Error while saving",
    loading: "Loading…",
    noPrefs: "No preferences available for your role.",
    saving: "Saving…",
    saveChanges: "Save changes",
  },
};
